// 共享模式配置
<template>
    <div class="share-mode-box">
        <div class="view-box">
            <div class="screen-switch">
                <div class="screen-item" :class="{'is-active': currentScreen === item.id}" v-for="item in screenSwitchList" :key="item.id" @click="screenSwitch(item)">
                    <i class="icon" :class="{'portrait-icon': item.id === 1, 'landscape-icon': item.id === 2}"></i>{{item.name}}
                </div>
            </div>
            <div class="view-wrap">
                <div class="view">
                    <div class="portrait-view" v-show="currentScreen === 1">
                        <div id="portraitVideoShareMode" class="video" :style="`width:${portrait.videoAreaWidth}px; top: ${portrait.videoAreaTop}px; transform: translate(${portrait.videoAreaCenterX}px);`">
                            <div v-for="(item, index) in portrait.videoList" :key="index" class="video-item" :style="`width: ${portrait.videoWidth}px;height: ${portrait.videoHeight}px`">
                                <div class="more-icon-box">
                                    <div class="more-icon"></div>
                                </div>
                                <div class="portrait-video-img-share-mode"></div>
                                <div class="portrait-video-name-box-share-mode">
                                    <div class="name">{{!index ? '主持人':'成员'}}</div>
                                    <div class="mic-icon"></div>
                                </div>
                            </div>
                        </div>
                        <div class="share" :style="`top:${portrait.shareAreaCenter}px;padding-left:${portrait.shareAreaLeft}px;padding-right:${portrait.shareAreaRight}px`">
                            <div id="portraitShareImg" class="share-img" :style="`width:${portrait.shareAreaWidth}px;height:${portrait.shareAreaHeight}px;`"></div>
                        </div>
                        <div class="tool-box" :style="`top:${portrait.toolTop}px;right:${portrait.toolRight}px`">
                            <div class="tool-box-item" v-for="(item, index) in toolBoxList" :key="index">
                                <div class="icon" :class="[item.icon]"></div>
                                <div class="name">{{item.name}}</div>
                            </div>
                        </div>
                        <div id="portraitImShareMode" class="im-box" :class="{'tile': portrait.discussStyle === 2}">
                            <div class="discuss">
                                <span>讨论</span>
                                <div class="hide-icon"></div>
                            </div>
                            <div class="im-item">
                                <span class="label">主持人</span>
                                <span class="name">主持人：</span>
                                <span class="text">以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！</span>
                            </div>
                            <div class="im-item" v-for="i in 9" :key="i">
                                <span class="name">成员：</span>
                                <span class="text">以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！</span>
                            </div>
                        </div>
                    </div>
                    <div class="landscape-view" v-show="currentScreen === 2">
                        <div id="landscapeVideoShareMode" class="video" :style="`width:${landscape.videoAreaWidth}px; top: ${landscape.videoAreaTop}px; transform: translate(${landscape.videoAreaCenterX}px);`">
                            <div v-for="(item, index) in landscape.videoList" :key="index" class="video-item" :style="`width: ${landscape.videoWidth}px;height: ${landscape.videoHeight}px`">
                                <div class="more-icon-box">
                                    <div class="more-icon"></div>
                                </div>
                                <div class="landscape-video-img-share-mode"></div>
                                <div class="landscape-video-name-box-share-mode">
                                    <div class="name">{{!index ? '主持人':'成员'}}</div>
                                    <div class="mic-icon"></div>
                                </div>
                            </div>
                        </div>
                        <div class="share" :style="`top:${landscape.shareAreaCenter}px;padding-left:${landscape.shareAreaLeft}px;padding-right:${landscape.shareAreaRight}px`">
                            <div id="landscapeShareImg" class="share-img" :style="`width:${landscape.shareAreaWidth}px;height:${landscape.shareAreaHeight}px;`"></div>
                        </div>
                        <div class="tool-box landscape" :style="`top:${landscape.toolTop}px;right:${landscape.toolRight}px`">
                            <div class="tool-box-item" v-for="(item, index) in toolBoxList" :key="index">
                                <div class="icon" :class="[item.icon]"></div>
                                <div class="name">{{item.name}}</div>
                            </div>
                        </div>
                        <div id="landscapeImShareMode" class="im-box" :class="{'tile': landscape.discussStyle === 2}">
                            <div class="discuss">
                                <span>讨论</span>
                                <div class="hide-icon"></div>
                            </div>
                            <div class="im-item">
                                <span class="label">主持人</span>
                                <span class="name">主持人：</span>
                                <span class="text">以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！</span>
                            </div>
                            <div class="im-item" v-for="i in 6" :key="i">
                                <span class="name">成员：</span>
                                <span class="text">以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="control-box">
            <div class="portrait-control-box" v-show="currentScreen === 1">
                <div class="video-area">
                    <div class="title">视频区域配置</div>
                    <div class="slider-item">
                        <div class="item-name">中心偏移</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.videoAreaCenterX" :min="-187" :max="187" @input="videoAreaChange($event, 'centerX', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">顶部边距</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.videoAreaTop" :max="667" @input="videoAreaChange($event, 'top', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">区域宽度</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.videoAreaWidth" :max="375" @input="videoAreaChange($event, 'width', 'portrait')" show-input :format-tooltip="formatTooltip"></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">区域高度</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.videoAreaHeight" :max="667" @input="videoAreaChange($event, 'height', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                </div>
                <div class="video-layout">
                    <div class="title">多人连麦视频布局配置</div>
                    <div class="video-layout-item">
                        <div class="item-name">多人布局</div>
                        <div class="item-content">
                            <div class="item-input">
                                行:
                                <el-input v-model="portrait.row" type="number" @input="numChange($event, 'row', 'portrait')"></el-input>
                            </div>
                            <div class="item-input">
                                列:
                                <el-input v-model="portrait.column" type="number" @input="numChange($event, 'column','portrait')"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="video-layout-item">
                        <div class="item-name">主持人固定位置</div>
                        <el-switch
                            v-model="portrait.hostFixed"
                            active-color="#2563EB"
                            @change="hostFixedChange($event, 'portrait')"
                        >
                        </el-switch>
                    </div>
                    <div class="video-layout-item">
                        <div class="item-name">多人视频窗口展示</div>
                        <el-select v-model="portrait.videoCountChange" placeholder="请选择" @change="videoCountChange($event, 'portrait')">
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="video-layout-item">
                        <div class="item-name">视频两侧展示翻页控件</div>
                        <el-switch
                            v-model="portrait.videoPageButtonShow"
                            active-color="#2563EB"
                            @change="videoPageButtonShowChange($event, 'portrait')"
                        >
                        </el-switch>
                    </div>
                </div>
                <div class="share-area">
                    <div class="title">共享区域布局配置</div>
                    <div class="slider-item">
                        <div class="item-name">左边距</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.shareAreaLeft" :max="187" @input="shareAreaChange($event, 'left', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">右边距</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.shareAreaRight" :max="187" @input="shareAreaChange($event, 'right', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">顶部边距</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.shareAreaCenter" :max="667" @input="shareAreaChange($event, 'center', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="share-area-item">
                        <div class="item-name">宽高比</div>
                        <div>
                            <el-input v-model="portrait.shareAreaRatioWidth" maxlength="2" @input="ratioChange($event, 'width', 'portrait')"></el-input>:
                            <el-input v-model="portrait.shareAreaRatioHeight" maxlength="2" @input="ratioChange($event, 'height','portrait')"></el-input>
                        </div>
                    </div>
                </div>
                <div class="tool-box">
                     <div class="title">标注工具布局配置</div>
                    <div class="slider-item">
                        <div class="item-name">顶部边距</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.toolTop" :max="667" @input="toolBoxChange($event, 'top', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">右边距</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.toolRight" :max="375" @input="toolBoxChange($event, 'right', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <!-- <div class="slider-item">
                        <div class="item-name">宽度</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.toolWidth" :max="667" @input="toolBoxChange($event, 'bottom', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">高度</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.toolHeight" :max="667" @input="toolBoxChange($event, 'bottom', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div> -->
                </div>
                <div class="discuss-area">
                    <div class="title">讨论展示配置</div>
                     <div class="discuss-area-item">
                        <div class="item-name">讨论样式</div>
                        <el-select v-model="portrait.discussStyle" placeholder="请选择" @change="discussStyleChange($event, 'portrait')">
                            <el-option
                                v-for="item in discussStyleOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">底部边距</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.discussAreaBottom" :max="667" @input="dicussAreaChange($event, 'bottom', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">左边距</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.discussAreaLeft" :max="375" @input="dicussAreaChange($event, 'left', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">区域宽度</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.discussAreaWidth" :max="375" @input="dicussAreaChange($event, 'width', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">区域高度</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.discussAreaHeight" :max="667" @input="dicussAreaChange($event, 'height', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="landscape-control-box" v-show="currentScreen === 2">
                 <div class="video-area">
                    <div class="title">视频区域配置</div>
                    <div class="slider-item">
                        <div class="item-name">中心偏移</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.videoAreaCenterX" :min="-333" :max="333" @input="videoAreaChange($event, 'centerX', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">顶部边距</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.videoAreaTop" :max="375" @input="videoAreaChange($event, 'top', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">区域宽度</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.videoAreaWidth" :max="677" @input="videoAreaChange($event, 'width', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">区域高度</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.videoAreaHeight" :max="375" @input="videoAreaChange($event, 'height', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                </div>
                <div class="video-layout">
                    <div class="title">多人连麦视频布局配置</div>
                    <div class="video-layout-item">
                        <div class="item-name">多人布局</div>
                        <div class="item-content">
                            <div class="item-input">
                                行：
                                <el-input v-model="landscape.row" type="number" @input="numChange($event, 'row', 'landscape')"></el-input>
                            </div>
                            <div class="item-input">
                                列：
                                <el-input v-model="landscape.column" type="number" @input="numChange($event, 'column','landscape')"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="video-layout-item">
                        <div class="item-name">主持人固定位置</div>
                        <el-switch
                            v-model="landscape.hostFixed"
                            active-color="#2563EB"
                            @change="hostFixedChange($event, 'landscape')"
                        >
                        </el-switch>
                    </div>
                    <div class="video-layout-item">
                        <div class="item-name">多人视频窗口展示</div>
                        <el-select v-model="landscape.videoCountChange" placeholder="请选择" @change="videoCountChange($event, 'landscape')">
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="video-layout-item">
                        <div class="item-name">视频两侧展示翻页控件</div>
                        <el-switch
                            v-model="landscape.videoPageButtonShow"
                            active-color="#2563EB"
                            @change="videoPageButtonShowChange($event, 'landscape')"
                        >
                        </el-switch>
                    </div>
                </div>
                <div class="share-area">
                    <div class="title">共享区域布局配置</div>
                    <div class="slider-item">
                        <div class="item-name">左边距</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.shareAreaLeft" :max="667" @input="shareAreaChange($event, 'left', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">右边距</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.shareAreaRight" :max="667" @input="shareAreaChange($event, 'right', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">顶部边距</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.shareAreaCenter" :max="375" @input="shareAreaChange($event, 'center', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="share-area-item">
                        <div class="item-name">宽高比</div>
                        <div>
                            <el-input v-model="landscape.shareAreaRatioWidth" maxlength="2" @input="ratioChange($event, 'width', 'landscape')"></el-input>:
                            <el-input v-model="landscape.shareAreaRatioHeight" maxlength="2" @input="ratioChange($event, 'height','landscape')"></el-input>
                        </div>
                    </div>
                </div>
                <div class="tool-box">
                     <div class="title">标注工具布局配置</div>
                    <div class="slider-item">
                        <div class="item-name">顶部边距</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.toolTop" :max="375" @input="toolBoxChange($event, 'top', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">右边距</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.toolRight" :max="667" @input="toolBoxChange($event, 'right', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <!-- <div class="slider-item">
                        <div class="item-name">宽度</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.toolWidth" :max="375" @input="toolBoxChange($event, 'width', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">高度</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.toolHeight" :max="667" @input="toolBoxChange($event, 'height', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div> -->
                </div>
                <div class="discuss-area">
                    <div class="title">讨论展示配置</div>
                     <div class="discuss-area-item">
                        <div class="item-name">讨论样式</div>
                        <el-select v-model="landscape.discussStyle" placeholder="请选择" @change="discussStyleChange($event, 'landscape')">
                            <el-option
                                v-for="item in discussStyleOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">底部边距</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.discussAreaBottom" :max="667" @input="dicussAreaChange($event, 'bottom', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">左边距</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.discussAreaLeft" :max="375" @input="dicussAreaChange($event, 'left', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">区域宽度</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.discussAreaWidth" :max="667" @input="dicussAreaChange($event, 'width', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">区域高度</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.discussAreaHeight" :max="375" @input="dicussAreaChange($event, 'height', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    config: {
      type: Object,
      default: Object
    }
  },
  data () {
    return {
      screenSwitchList: [
        {
          id: 1,
          name: '竖屏'
        },
        {
          id: 2,
          name: '横屏'
        }
      ],
      currentScreen: 1,
      portrait: {
        videoList: [],
        videoAreaTop: 0,
        videoAreaWidth: 0,
        videoAreaHeight: 0,
        videoAreaCenterX: 0,
        row: 0,
        column: 0,
        hostFixed: true,
        videoCountChange: 1,
        videoPageButtonShow: 1,
        shareAreaLeft: 0,
        shareAreaRight: 0,
        shareAreaCenter: 0,
        shareAreaWidth: 0,
        shareAreaHeight: 0,
        shareAreaRatioWidth: 16,
        shareAreaRatioHeight: 9,
        toolTop: 0,
        toolRight: 0,
        discussStyle: 1,
        discussAreaLeft: 0,
        discussAreaBottom: 0,
        discussAreaWidth: 0,
        discussAreaHeight: 0,
        pageWidth: 36
      },
      landscape: {
        videoList: [],
        videoAreaTop: 0,
        videoAreaWidth: 0,
        videoAreaHeight: 0,
        videoAreaCenterX: 0,
        row: 0,
        column: 0,
        hostFixed: true,
        videoCountChange: 1,
        videoPageButtonShow: 1,
        shareAreaLeft: 0,
        shareAreaRight: 0,
        shareAreaCenter: 0,
        shareAreaWidth: 0,
        shareAreaHeight: 0,
        shareAreaRatioWidth: 16,
        shareAreaRatioHeight: 9,
        toolTop: 0,
        toolRight: 0,
        discussStyle: 1,
        discussAreaLeft: 0,
        discussAreaBottom: 0,
        discussAreaWidth: 0,
        discussAreaHeight: 0,
        pageWidth: 36
      },
      options: [
        {
          label: '固定展示',
          value: 1
        },
        {
          label: '动态变化',
          value: 2
        }
      ],
      discussStyleOptions: [
        {
          label: '弹幕式',
          value: 1
        },
        {
          label: '平铺式',
          value: 2
        }
      ],
      toolBoxList: [
        {
          icon: 'tool-click-icon',
          name: '点击'
        },
        {
          icon: 'tool-select-icon',
          name: '选择'
        },
        {
          icon: 'tool-drag-icon',
          name: '拖拽'
        },
        {
          icon: 'tool-laser-pen-icon',
          name: '激光笔'
        },
        {
          icon: 'tool-brush-icon',
          name: '画笔'
        },
        {
          icon: 'tool-text-icon',
          name: '文本'
        },
        {
          icon: 'tool-eraser-icon',
          name: '橡皮擦'
        },
        {
          icon: 'tool-more-icon',
          name: '更多'
        }
      ]

    }
  },
  watch: {
    config (val) {
      // 获取父组件调用接口请求后的配置文件
      this.config = val
      this.currentScreen = 1
      this.getConfigData()
    }
  },
  mounted () {
    this.portrait.viewWidth = 375// document.getElementsByClassName('portrait-view')[0].clientWidth
    this.portrait.viewHeight = 667// document.getElementsByClassName('portrait-view')[0].clientHeight
    this.landscape.viewWidth = this.portrait.viewHeight
    this.landscape.viewHeight = this.portrait.viewWidth
    this.getConfigData()
  },
  methods: {
    screenSwitch (data) {
      this.currentScreen = data.id
    },
    getConfigData () {
      this.transConfigData('portrait')
      this.transConfigData('landscape')
    },
    // 根据最新config赋值
    transConfigData (screen) {
      if (this.config[screen].share_videoView.video_page_button_show === 1) {
        this.videoPageButtonShowChange(false, screen)
      } else {
        this.videoPageButtonShowChange(true, screen)
      }
      // 视频区域的行和列
      this[screen].row = this.config[screen].share_videoView.row
      this[screen].column = this.config[screen].share_videoView.column
      this[screen].hostFixed = this.config[screen].share_videoView.host_video_fixed === 2
      this[screen].videoCountChange = this.config[screen].share_videoView.video_count_change
      this[screen].videoPageButtonShow = this.config[screen].share_videoView.video_page_button_show === 2
      // 视频区域的中心偏移 宽度 高度
      this[screen].videoAreaCenterX = this.config[screen].share_videoView.position.centerX
      this[screen].videoAreaTop = this.config[screen].share_videoView.position.top
      this[screen].videoAreaWidth = (this.config[screen].share_videoView.item_width * this.config[screen].share_videoView.column) + (1 * (this.config[screen].share_videoView.column - 1)) + (this.config[screen].share_videoView.video_page_button_show === 2 ? 36 : 6)
      this[screen].videoAreaHeight = this.config[screen].share_videoView.position.height
      // 单个视频窗口的宽高
      // this[screen].videoWidth = this.config[screen].share_videoView.item_width ? this.config[screen].share_videoView.item_width : 114
      this[screen].videoHeight = this.config[screen].share_videoView.item_height ? this.config[screen].share_videoView.item_height : 60
      // 共享区域的左边距 右边距 顶部边距
      this[screen].shareAreaLeft = this.config[screen].shareView.position.left
      this[screen].shareAreaRight = this.config[screen].shareView.position.right
      this[screen].shareAreaCenter = this.config[screen].shareView.position.top_RPN
        ? this.calculate(this.config[screen].shareView.position.top_RPN, screen) : this.config[screen].shareView.position.top
      this[screen].shareAreaWidth = screen === 'portrait' ? 375 : 667
      this[screen].shareAreaHeight = screen === 'portrait' ? 375 / this[screen].shareAreaRatioWidth * this[screen].shareAreaRatioHeight : 667 / this[screen].shareAreaRatioWidth * this[screen].shareAreaRatioHeight
      this[screen].shareAreaRatioWidth = String(this.config[screen].shareView.position.height_RPN).split(' ')[4]
      this[screen].shareAreaRatioHeight = String(this.config[screen].shareView.position.height_RPN).split(' ')[2]
      // 标注工具的顶部边距 左边距
      this[screen].toolTop = this.config[screen].boardToolView.position.top
      this[screen].toolRight = this.config[screen].boardToolView.position.right
      // 讨论区域的样式 底部/左边距 宽度 高度
      this[screen].discussStyle = this.config[screen].share_messageView.im_type
      this[screen].discussAreaBottom = this.config[screen].share_messageView.position.bottom
      this[screen].discussAreaLeft = this.config[screen].share_messageView.position.left
      this[screen].discussAreaWidth = this.config[screen].share_messageView.position.width
      this[screen].discussAreaHeight = this.config[screen].share_messageView.position.height
      this.numChange(this[screen].column + '', 'column', screen)
    },
    // 视频区域样式更改
    videoAreaChange (val, type, screen) {
      // 更新config配置
      switch (type) {
        case 'top':
          this.config[screen].share_videoView.position.top = val
          break
        case 'width':
          this[screen].videoWidth = ((val - this[screen].pageWidth) - ((this[screen].column - 1) * 1)) / this[screen].column
          this.config[screen].share_videoView.item_width = this[screen].videoWidth
          this.config[screen].share_videoView.position.width = val
          break
        case 'height':
          this[screen].videoHeight = ((val - 6) - ((this[screen].row - 1) * 1)) / this[screen].row
          this.config[screen].share_videoView.item_height = this[screen].videoHeight
          this.config[screen].share_videoView.position.height = val
          break
        case 'centerX':
          this.config[screen].share_videoView.position.centerX = val
          break
      }
      this.updateVideoView(screen)
    },
    // 视频区行和列更改
    numChange (val, type, screen) {
      this[screen].videoList = []
      if (screen === 'landscape') {
        this.landscape[type] = Number(val)
        if (type === 'column' && val > 4) {
          this.landscape.column = 4
        }
        if (type === 'row' && val > 3) {
          this.landscape.row = 3
        }
        this.config.landscape.share_videoView[type] = this.landscape[type]
      } else {
        this.portrait[type] = Number(val)
        if (val > 3) {
          this.portrait[type] = 3
        }
        this.config.portrait.share_videoView[type] = this.portrait[type]
      }
      for (let i = 0; i < this[screen].row * this[screen].column; i++) {
        this[screen].videoList.push({
          name: i
        })
      }
      // 固定展示时更新video_count
      if (this.config[screen].share_videoView.video_count_change === 1) {
        this.config[screen].share_videoView.video_count = this[screen].row * this[screen].column
      }
      // 视频窗口数量变化时需要调整视频窗口之间的间隙
      switch (type) {
        case 'row':
          switch (val) {
            case '1':
              this[screen].videoHeight = this[screen].videoAreaHeight - 6
              this.$nextTick(() => {
                if (this[screen].column === 1) {
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(1)`).classList.remove('marginB')
                } else if (this[screen].column === 2) {
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(1)`).classList.remove('marginB')
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(2)`).classList.remove('marginB')
                } else if (this[screen].column === 3) {
                  for (let i = 0; i < 3; i++) {
                    document.querySelector(`#${screen}VideoShareMode > div:nth-child(${i + 1})`).classList.remove('marginB')
                  }
                }
              })
              break
            case '2':
              this[screen].videoHeight = (this[screen].videoAreaHeight - 6 - 1) / 2
              this.$nextTick(() => {
                if (this[screen].column === 2) {
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(1)`).classList.add('marginB')
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(2)`).classList.add('marginB')
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(3)`).classList.remove('marginB')
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(4)`).classList.remove('marginB')
                } else if (this[screen].column === 3) {
                  for (let i = 0; i < 3; i++) {
                    document.querySelector(`#${screen}VideoShareMode > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                  for (let j = 3; j < 6; j++) {
                    document.querySelector(`#${screen}VideoShareMode > div:nth-child(${j + 1})`).classList.remove('marginB')
                  }
                } else if (this[screen].column === 1) {
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(1)`).classList.add('marginB')
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(2)`).classList.remove('marginB')
                } else if (this[screen].column === 4) {
                  for (let i = 0; i < 4; i++) {
                    document.querySelector(`#${screen}VideoShareMode > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                  for (let j = 4; j < 8; j++) {
                    document.querySelector(`#${screen}VideoShareMode > div:nth-child(${j + 1})`).classList.remove('marginB')
                  }
                }
              })
              break
            case '3':
              this[screen].videoHeight = (this[screen].videoAreaHeight - 6 - 2) / 3
              this.$nextTick(() => {
                if (this[screen].column === 1) {
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(1)`).classList.add('marginB')
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(2)`).classList.add('marginB')
                } else if (this[screen].column === 2) {
                  for (let i = 0; i < 4; i++) {
                    document.querySelector(`#${screen}VideoShareMode > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                } else if (this[screen].column === 3) {
                  for (let i = 0; i < 6; i++) {
                    document.querySelector(`#${screen}VideoShareMode > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                } else if (this[screen].column === 4) {
                  for (let i = 0; i < 8; i++) {
                    document.querySelector(`#${screen}VideoShareMode > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                }
              })

              break
          }
          break
        case 'column':
          switch (val) {
            case '1':
              this[screen].videoWidth = this[screen].videoAreaWidth - this[screen].pageWidth
              this.config[screen].share_videoView.item_width = this[screen].videoWidth
              this.$nextTick(() => {
                if (this[screen].row === 2) {
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(1)`).classList.add('marginB')
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(2)`).classList.remove('marginB')
                } else if (this[screen].row === 3) {
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(3)`).classList.remove('marginB')
                }
              })
              break
            case '2':
              this[screen].videoWidth = (this[screen].videoAreaWidth - this[screen].pageWidth - 1) / 2
              this.config[screen].share_videoView.item_width = this[screen].videoWidth
              this.$nextTick(() => {
                if (this[screen].row === 2) {
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(1)`).classList.add('marginB')
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(2)`).classList.add('marginB')
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(3)`).classList.remove('marginB')
                } else if (this[screen].row === 3) {
                  for (let i = 0; i < 4; i++) {
                    document.querySelector(`#${screen}VideoShareMode > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(5)`).classList.remove('marginB')
                  document.querySelector(`#${screen}VideoShareMode > div:nth-child(6)`).classList.remove('marginB')
                }
              })
              break
            case '3':
              this[screen].videoWidth = (this[screen].videoAreaWidth - this[screen].pageWidth - 2) / 3
              this.config[screen].share_videoView.item_width = this[screen].videoWidth
              this.$nextTick(() => {
                if (this[screen].row === 2) {
                  for (let i = 0; i < 3; i++) {
                    document.querySelector(`#${screen}VideoShareMode > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                } else if (this[screen].row === 3) {
                  for (let i = 0; i < 6; i++) {
                    document.querySelector(`#${screen}VideoShareMode > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                }
              })
              break
            case '4':
              this.landscape.videoWidth = (this.landscape.videoAreaWidth - this[screen].pageWidth - 3) / 4
              this.config.landscape.share_videoView.item_width = this.landscape.videoWidth
              this.$nextTick(() => {
                if (this[screen].row === 2) {
                  for (let i = 0; i < 3; i++) {
                    document.querySelector(`#${screen}VideoShareMode > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                } else if (this[screen].row === 3) {
                  for (let i = 0; i < 6; i++) {
                    document.querySelector(`#${screen}VideoShareMode > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                }
              })
              break
          }
          break
      }
      this.updateVideoView(screen)
    },
    // 根据视频区域和行列更新view
    updateVideoView (screen) {
      // 视频窗口高度小于100时需要调整样式
      this.$nextTick(() => {
        const videoImgList = Array.from(document.getElementsByClassName(`${screen}-video-img-share-mode`))
        const videoNameBoxList = Array.from(document.getElementsByClassName(`${screen}-video-name-box-share-mode`))
        if (this[screen].videoHeight < 100) {
          videoImgList.forEach((item) => {
            item.classList.add('small')
          })
          videoNameBoxList.forEach((item) => {
            item.classList.add('small')
          })
        } else {
          videoImgList.forEach((item) => {
            item.classList.remove('small')
          })
          videoNameBoxList.forEach((item) => {
            item.classList.remove('small')
          })
        }
      })
    },
    // 主持人固定位置更改
    hostFixedChange (val, screen) {
      this.config[screen].share_videoView.host_video_fixed = val ? 2 : 1
    },
    // 坐席展示更改
    videoCountChange (val, screen) {
      this[screen].videoCountChange = val
      this.config[screen].share_videoView.video_count_change = val
      if (this.config[screen].share_videoView.video_count_change === 1) {
        this.config[screen].share_videoView.video_count = this[screen].row * this[screen].column
      }
    },
    videoPageButtonShowChange (val, screen) {
      this.config[screen].share_videoView.video_page_button_show = val ? 2 : 1
      const dom = document.getElementById(`${screen}VideoShareMode`)
      if (!val) {
        // 无翻页按钮区域
        dom.style.padding = '3px 3px'
        this[screen].pageWidth = 6
        this[screen].videoWidth = (this[screen].videoAreaWidth - this[screen].pageWidth - 1 * (this[screen].column - 1)) / this[screen].column
      } else {
        dom.style.padding = '3px 18px'
        this[screen].pageWidth = 36
        this[screen].videoWidth = (this[screen].videoAreaWidth - this[screen].pageWidth - 1 * (this[screen].column - 1)) / this[screen].column
      }
      console.log('videoPageButtonShowChange', val, screen, this[screen].pageWidth)
    },
    shareAreaChange (val, type, screen) {
      switch (type) {
        case 'left':
          this.config[screen].shareView.position.left = val
          this[screen].shareAreaLeft = val
          this[screen].shareAreaWidth = screen === 'portrait'
            ? 375 - this[screen].shareAreaLeft - this[screen].shareAreaRight : 667 - this[screen].shareAreaLeft - this[screen].shareAreaRight
          this[screen].shareAreaHeight = this[screen].shareAreaWidth / this[screen].shareAreaRatioWidth * this[screen].shareAreaRatioHeight
          this.config[screen].shareView.position.height_RPN = `workView width ${this[screen].shareAreaRatioHeight} * ${this[screen].shareAreaRatioWidth} / ${this[screen].shareAreaLeft} - ${this[screen].shareAreaRight} -`
          break
        case 'right':
          this.config[screen].shareView.position.right = val
          this[screen].shareAreaRight = val
          this[screen].shareAreaWidth = screen === 'portrait'
            ? 375 - this[screen].shareAreaLeft - val : 667 - this[screen].shareAreaLeft - val
          this[screen].shareAreaHeight = this[screen].shareAreaWidth / this[screen].shareAreaRatioWidth * this[screen].shareAreaRatioHeight
          this.config[screen].shareView.position.height_RPN = `workView width ${this[screen].shareAreaRatioHeight} * ${this[screen].shareAreaRatioWidth} / ${this[screen].shareAreaLeft} - ${this[screen].shareAreaRight} -`
          break
        case 'center':
          this.config[screen].shareView.position.top_RPN
            ? this.config[screen].shareView.position.top_RPN = `workView height ${(this[screen].shareAreaCenter / 667).toFixed(2)} *` : this.config[screen].shareView.position.top = val
          this[screen].shareAreaCenter = val
      }
    },
    ratioChange (val, type, screen) {
      this[screen].shareAreaHeight = this[screen].shareAreaWidth / this[screen].shareAreaRatioWidth * this[screen].shareAreaRatioHeight
      this.config[screen].shareView.position.height_RPN = `workView width ${this[screen].shareAreaRatioHeight} * ${this[screen].shareAreaRatioWidth} / ${this[screen].shareAreaLeft} - ${this[screen].shareAreaRight} -`
    },
    toolBoxChange (val, type, screen) {
      switch (type) {
        case 'top':
          this.config[screen].boardToolView
            ? this.config[screen].boardToolView.position.top = val : this.config[screen].boardToolView.position.top = val
          this[screen].toolTop = val
          break
        case 'right':
          this.config[screen].boardToolView
            ? this.config[screen].boardToolView.position.right = val : this.config[screen].boardToolView.position.right = val
          this[screen].toolRight = val
          break
      }
    },
    // 讨论区样式
    discussStyleChange (val, screen) {
      this.config[screen].share_messageView.im_type = val
    },
    // 讨论区域位置更更改
    dicussAreaChange (val, type, screen) {
      const discussAreaDom = document.querySelector(`#${screen}ImShareMode`)
      switch (type) {
        case 'bottom':
          discussAreaDom.style.bottom = val + 'px'
          this.config[screen].share_messageView.position.bottom = val
          break
        case 'left':
          discussAreaDom.style.left = val + 'px'
          this.config[screen].share_messageView.position.left = val
          break
        case 'width':
          discussAreaDom.style.width = val + 'px'
          this.config[screen].share_messageView.position.width
            ? this.config[screen].share_messageView.position.width = val
            : this.config[screen].share_messageView.position.width_RPN = `workView height 0.25 * ${this[screen].shareAreaRatioWidth} * ${this[screen].shareAreaRatioHeight} / 0.5 -`
          break
        case 'height':
          discussAreaDom.style.height = val + 'px'
          this.config[screen].share_messageView.position.height = val
          break
      }
    },
    formatTooltip (val) {
      console.log('val', val)
      // return val.toFixed(1)
    },
    calculate (string, screen) {
      const arr = string.split(' ')
      if (arr[1] === 'height') {
        let str = ''
        let result = String(this[screen].viewHeight)
        for (let i = 2; i < arr.length; i++) {
          if (i % 2 === 0) {
            str = arr[i] + str
          } else {
            // eslint-disable-next-line no-eval
            result = eval(String(result) + arr[i] + str)
            str = ''
          }
        }
        return parseInt(result)
      } else if (arr[1] === 'width') {
        let str = ''
        let result = String(this[screen].viewWidth)
        for (let i = 2; i < arr.length; i++) {
          if (i % 2 === 0) {
            str = arr[i] + str
          } else {
            // eslint-disable-next-line no-eval
            result = eval(String(result) + arr[i] + str)
            str = ''
          }
        }
        return parseInt(result)
      } else if (arr[1] === 'right') {
        // let str = ''
        // let result =
      }
    }
  }
}
</script>
<style lang="less" scoped>
.share-mode-box {
    display: flex;
    border-radius: 4px;
    width: 100%;
    min-height: 100%;
    .view-box {
        overflow: scroll;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 160px;
        .screen-switch {
            flex-shrink: 0;
            margin: 24px 0;
            display: flex;
            width: 160px;
            height: 32px;
            background-color: #FFFFFF;
            box-shadow: 0px 2px 16px 0px rgba(218, 222, 232, 0.06);
            border-radius: 4px;
            .screen-item {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50%;
                height: 100%;
                cursor: pointer;
                font-size: 12px;
                color: #636c78;
                .icon{
                    display: flex;
                    align-items: center;
                    width: 20px;
                    height: 20px;
                    &.portrait-icon{
                        margin-left: -3px;
                        margin-right: 1px;
                        background-image: url('../assets/img/portrait-icon.png');
                        background-size: cover;
                    }
                    &.landscape-icon{
                        margin-left: -3px;
                        margin-right: 5px;
                        background-image: url('../assets/img/landscape-icon.png');
                        background-size: cover;
                    }
                }
                &.is-active{
                    background-color: rgba(37, 99, 235, 0.1);
                    box-shadow: 0px 2px 16px 0px rgba(218, 222, 232, 0.06);
                    border-radius: 4px;
                    border: 1px solid #0062F4;
                    color: #2563EB;
                    .icon{
                        &.portrait-icon{
                            background-image: url('../assets/img/portrait-icon-active.png');
                        }
                        &.landscape-icon{
                            background-image: url('../assets/img/landscape-icon-active.png');
                        }
                    }
                }
            }
        }
        .view-wrap {
            display: flex;
            align-items: center;
            flex-grow: 1;
            .view {
                overflow: hidden;
                background-color: #171717;
                .portrait-view, .landscape-view{
                    position: relative;
                    display: flex;
                    justify-content: center;
                    width: 375px;
                    height: 667px;
                    .video {
                        z-index: 2;
                        position: absolute;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        flex-wrap: wrap;
                        background-color: #343434;
                        padding: 3px 18px;
                        border-radius: 3px;
                        .video-item{
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: space-between;
                            background-color: #1E1E1E;
                            overflow: hidden;
                            .more-icon-box {
                                align-self: flex-end;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                margin: 4px 4px 0 0;
                                width: 18px;
                                height: 14px;
                                background-color: rgba(0, 0, 0, 0.6);
                                border-radius: 3px;
                                .more-icon {
                                    width: 100%;
                                    height: 100%;
                                    background-image: url('../assets/img/video-more.png');
                                    background-size: cover;
                                }
                            }
                            .portrait-video-img-share-mode, .landscape-video-img-share-mode {
                                width: 41px;
                                height: 41px;
                                background-image: url('../assets/img/video-default-big.png');
                                background-size: cover;
                                &.small {
                                    width: 25px;
                                    height: 25px;
                                }
                            }
                            .portrait-video-name-box-share-mode, .landscape-video-name-box-share-mode {
                                align-self: flex-end;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                margin: 0 4px 4px 0;
                                padding: 0 8px;
                                // min-width: 24px;
                                height: 18px;
                                background-color: #000;
                                border-radius: 9px;
                                .name {
                                    margin-bottom: 1px;
                                    font-size: 20px;
                                    color: #fff;
                                    zoom: 0.5;
                                }
                                .mic-icon {
                                    margin-left: 2px;
                                    width: 10px;
                                    height: 10px;
                                    background-image: url('../assets/img/video-microphone-icon.png');
                                    background-size: cover;
                                }
                                &.small {
                                    margin: 0 3px 3px 0;
                                    padding: 0 5px;
                                    height: 16px;
                                    .name {
                                        font-size: 18px;
                                    }
                                }
                            }
                            &.marginB{
                                margin-bottom: 1px;
                            }
                            &.marginR{
                                margin-right: 1px;
                            }
                        }
                    }
                    .share {
                        z-index: 1;
                        position: absolute;
                        // top: 133.4px;
                        // width: 375px;
                        // height: 211.5px;
                        // overflow: hidden;
                        .share-img {
                            border: 1px solid #333333;
                            background-image: url('../assets/img/white-board-img.png');
                            background-size: cover;
                            background-position: center;
                        }
                    }
                    .tool-box {
                        z-index: 3;
                        position: absolute;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding: 4px;
                        background-color: #343434;
                        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
                        border-radius: 6px;
                        .tool-box-item {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            margin-right: 8px;
                            width: 30px;
                            height: 30px;
                            border-radius: 2px;
                            .icon {
                                margin-bottom: 2px;
                                width: 16px;
                                height: 16px;
                                background-size: cover;
                                &.tool-click-icon {
                                    background-image: url('../assets/img/tool-click-icon.png');
                                }
                                &.tool-select-icon {
                                    background-image: url('../assets/img/tool-select-icon.png');
                                }
                                &.tool-drag-icon {
                                    background-image: url('../assets/img/tool-drag-icon.png');
                                }
                                &.tool-laser-pen-icon {
                                    background-image: url('../assets/img/tool-laser-pen-icon.png');
                                }
                                &.tool-brush-icon {
                                    background-image: url('../assets/img/tool-brush-icon.png');
                                }
                                &.tool-text-icon {
                                    background-image: url('../assets/img/tool-text-icon.png');
                                }
                                &.tool-eraser-icon {
                                    background-image: url('../assets/img/tool-eraser-icon.png');
                                }
                                &.tool-more-icon {
                                    background-image: url('../assets/img/tool-more-icon.png');
                                }
                            }
                            .name {
                                font-size: 18px;
                                color: #E9E9E9;
                                zoom: 0.5;
                            }
                            &:nth-child(1) .name {
                                color: #808080;
                            }
                            &:nth-child(5) {
                                background-color: #E9E9E9;
                                .name {color: #1E1E1E;}
                            }
                            &:last-child {
                                margin-right: 0;
                            }
                        }
                        &.landscape {
                            flex-direction: column;
                            .tool-box-item {
                                margin-right: 0;
                                margin-bottom: 8px;
                                &:last-child {
                                    margin-bottom: 0;
                                }
                            }
                        }
                    }
                    .im-box {
                        z-index: 4;
                        position: absolute;
                        left: 0;
                        bottom: 3px;
                        display: flex;
                        flex-direction: column;
                        overflow: hidden;
                        &.tile {
                            .discuss {
                                display: none;
                            }
                            .im-item {
                                margin-bottom: 0;
                                border-radius: 0;
                                background-color: #121212;
                            }
                        }
                        .discuss {
                            flex-shrink: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin: 0 0 6px 10px;
                            width: 105px;
                            height: 36px;
                            line-height: 36px;
                            font-size: 20px;
                            color: #fff;
                            background-color: rgba(0,0,0,0.42);
                            border-radius: 8px;
                            zoom: 0.5;
                            .hide-icon {
                                margin-left: 10px;
                                width: 16px;
                                height: 12px;
                                background-image: url('../assets/img/im-hide-icon.png');
                                background-size: cover;
                            }
                        }
                        .im-item {
                            margin-bottom: 6px;
                            padding: 8px 12px;
                            // max-width: 255px;
                            width: fit-content;
                            background-color: rgba(0,0,0,0.42);
                            border-radius: 0 4px 4px 0;
                            .label {
                                display: inline-block;
                                vertical-align: middle;
                                margin-right: 6px;
                                padding: 4px 4px;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #fff;
                                background-color: #1A7BFF;
                                zoom: 0.5;
                                text-align: center;
                            }
                            .name {
                                font-size: 12px;
                                color: #1A7BFF;
                            }
                            .text{
                                font-size: 12px;
                                line-height: 16px;
                                color: #fff;
                            }
                        }
                    }
                }
                .landscape-view {
                    width: 667px;
                    height: 375px;
                }
            }
        }

    }
    .control-box {
        z-index: 6;
        position: fixed;
        right: 0;
        height: calc(100% - 64px);
        overflow: scroll;
        background-color: #FFFFFF;
        .portrait-control-box, .landscape-control-box {
            display: flex;
            flex-direction: column;
            width: 272px;
            background-color: #FFFFFF;
            font-size: 12px;
            .title {
                margin-bottom: 20px;
                font-size: 13px;
                font-weight: 600;
                color: #33383E
            }
            .slider-item {
                margin-bottom: 16px;
                &:last-child{
                    margin-bottom: 0;
                }
                .item-name {
                    margin-bottom: 2px;
                    color: #33383e;
                }
                .item-content {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .slider-text {
                        z-index: 1;
                        margin: 0 6px 4px 0;
                        font-size: 12px;
                        color: #9DA3AC;
                    }
                }
            }
            .video-area{
                padding: 24px 24px 8px;
            }
            .video-layout {
                padding: 24px 24px 8px;
                .video-layout-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    &:last-child{
                        margin-bottom: 0;
                    }
                    .item-name {
                        color: #33383e;
                    }
                    .item-content {
                        display: flex;
                        .item-input:nth-child(1) {
                            margin-right: 14px;
                        }
                        .el-input {
                            margin-left: 2px;
                            width: 32px;
                            height: 28px;
                        }
                    }
                }
            }
            .share-area {
                padding: 24px 24px 8px;
                .share-area-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    &:last-child{
                        margin-bottom: 0;
                    }
                    .el-input{
                        width: 42px;
                        height: 28px;
                        &:nth-child(1) {
                            margin-right: 5px;
                        }
                    }
                }
            }
            .tool-box {
                padding: 24px 24px 8px;
            }
            .discuss-area {
                padding: 24px 24px 32px;
                .discuss-area-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    .item-name {
                        color: #33383e;
                    }
                }
            }
        }
    }

}
</style>
<style scoped>
.el-slider {
    margin-right: 8px;
}
.el-input {
    font-size: 12px;
}
.el-input >>> .el-input__inner {
    padding: 0 10px;
    height: 28px;
    text-align: center;
    color: #33383e;
}
.el-slider >>> .el-input--small {
    font-size: 12px;
}
.el-slider >>> .el-slider__runway {
    margin: 13px 0 13px 5px;
    width: 154px;
    height: 2px;
}
.el-slider >>> .el-slider__button {
    width: 10px;
    height: 10px;
    border-color: #2563eb;
}
.el-slider >>> .el-slider__button-wrapper{
    width: 28px;
    height: 28px;
    top: -13px;
}
.el-slider >>> .el-slider__bar {
    height: 2px;
    background-color: #2563eb;
}
.el-slider >>> .el-slider__input{
    margin-top: -2px;
    width: 56px;
    height: 28px;
}
.el-slider >>> .el-input-number__decrease, .el-slider >>> .el-input-number__increase {
    display: none;
}
.el-slider >>> .el-input__inner {
    padding: 0 15px 0 0;
    margin-left: 64px;
    height: 28px;
    color: #33383e;
}
.el-select >>> .el-input__inner {
    padding-right: 0;
    padding-left: 10px;
    width: 82px;
    height: 28px;
    font-size: 12px;
    color: #33383e;
}
.el-select >>> .el-input__icon {
    display: flex;
    align-items: center;
    width: 12px;
    height: 28px;
    color: #919DAB;
}
.el-select >>> .el-input .el-select__caret.el-icon-arrow-up::before {
    background: url('../assets/img/arrow-icon.png');
    background-size: cover;
    transform: rotate(0deg);
}
.el-select >>> .el-input .el-select__caret.is-reverse.el-icon-arrow-up::before {
     transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/views/share-mode.vue